import React, { PureComponent } from 'react';
import { Row, Col, Button, ButtonToolbar } from 'reactstrap';
import DatabaseImportIcon from 'mdi-react/DatabaseImportIcon';
import { withTranslation } from 'react-i18next';
import { checkKey, hasAccess } from "../../Services/SecurityService";
import { check, findAllRequerimentoShapeFileByDeleted } from "../../Services/RequerimentoShapeFileService";
// import { findAllCidade } from "../../Services/CidadeService";
import { findAllEstado } from "../../Services/EstadoService";
import { findAllSubstancia } from "../../Services/SubstanciaService";
import { findAllSubstanciaUso } from "../../Services/SubstanciaUsoService";
import { findAllRequerimentoEvento } from "../../Services/RequerimentoEventoService";
import { findAllRequerimentoFase } from "../../Services/RequerimentoFaseService";

import PropTypes from 'prop-types';
import MatTable from './MaterialTable/MatTable';
import CrudEdit from './edit';
import { FullWideNotification } from '../../../shared/components/Notification';
import NotificationSystem from 'rc-notification';
import { util } from "../../../shared/util";

let notificationTC = null;

class CrudList extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      hasAccess: false,
      process: false,
      // cidades: {},
      estados: {},
      substancia: {},
      substanciaUso: {},
      requerimentoEventos: {},
      requerimentoFase: {},
      data: []
    };
    check();
  }

  loadRequerimentoShapeFile(process){
    findAllRequerimentoShapeFileByDeleted(0)
    .then(data => {
      if(data === undefined){
        data = [];
      }
      if(data !== undefined && data.error === undefined){
        this.setState({ data: data, process});
      } else {
        if(data.errors === undefined){
          data = [];
          this.show('danger', this.props.t('forms.errorListData'));
        } else {
          data = [];
          this.show('danger', data.errors[0].defaultMessage);
        }
      }
    });
  }

  loadEstado(){
    findAllEstado()
    .then(data => {
      if(data === undefined){
        data = [];
      }
      if(data !== undefined && data.error === undefined){
        let estadosMap = new Map();
        for(let i = 0; i < data.length; i++){
          estadosMap.set(data[i].uf.toLowerCase(), data[i]);
        }
        this.setState({ estados: estadosMap });
      } else {
        if(data.errors === undefined){
          data = [];
          this.show('danger', this.props.t('forms.errorListData'));
        } else {
          data = [];
          this.show('danger', data.errors[0].defaultMessage);
        }
      }
    })
  }

  loadSubstancia(){
    findAllSubstancia()
    .then(data => {
      if(data === undefined){
        data = [];
      }
      if(data !== undefined && data.error === undefined){
        let map = new Map();
        let name = "";
        for(let i = 0; i < data.length; i++){
          name = util.getTextNormalized(data[i].nameCarga || data[i].name);
          map.set(name.toLowerCase(), data[i]);
        }
        this.setState({ substancia: map });
      } else {
        if(data.errors === undefined){
          data = [];
          this.show('danger', this.props.t('forms.errorListData'));
        } else {
          data = [];
          this.show('danger', data.errors[0].defaultMessage);
        }
      }
    })
  }

  loadSubstanciaUso(){
    findAllSubstanciaUso()
    .then(data => {
      if(data === undefined){
        data = [];
      }
      if(data !== undefined && data.error === undefined){
        let map = new Map();
        let name = "";
        for(let i = 0; i < data.length; i++){
          name = util.getTextNormalized(data[i].nameCarga || data[i].name);
          map.set(name.toLowerCase(), data[i]);
        }
        this.setState({ substanciaUso: map });
      } else {
        if(data.errors === undefined){
          data = [];
          this.show('danger', this.props.t('forms.errorListData'));
        } else {
          data = [];
          this.show('danger', data.errors[0].defaultMessage);
        }
      }
    })
  }

  loadRequerimentoEvento(){
    findAllRequerimentoEvento()
    .then(data => {
      if(data === undefined){
        data = [];
      }
      if(data !== undefined && data.error === undefined){
        let map = new Map();
        for(let i = 0; i < data.length; i++){
          map.set(data[i].code, data[i]);
        }
        this.setState({ requerimentoEventos: map });
      } else {
        if(data.errors === undefined){
          data = [];
          this.show('danger', this.props.t('forms.errorListData'));
        } else {
          data = [];
          this.show('danger', data.errors[0].defaultMessage);
        }
      }
    })
  }

  loadRequerimentoFase(){
    findAllRequerimentoFase()
    .then(data => {
      if(data === undefined){
        data = [];
      }
      if(data !== undefined && data.error === undefined){
        let map = new Map();
        let name = "";
        for(let i = 0; i < data.length; i++){
          name = util.getTextNormalized(data[i].nameCarga || data[i].name);
          map.set(name.toLowerCase(), data[i]);
        }
        this.setState({ requerimentoFase: map });
      } else {
        if(data.errors === undefined){
          data = [];
          this.show('danger', this.props.t('forms.errorListData'));
        } else {
          data = [];
          this.show('danger', data.errors[0].defaultMessage);
        }
      }
    })
  }
  

  componentDidMount() {
    NotificationSystem.newInstance({ style: { top: 65 } }, n => notificationTC = n);
    if(checkKey("MENU_REQUIREMENT_SHP")){
      this.loadRequerimentoShapeFile(false);
      //this.loadCidades();
      this.loadEstado();
      this.loadSubstancia();
      this.loadSubstanciaUso();
      this.loadRequerimentoEvento();
      this.loadRequerimentoFase();
      this.setState({ hasAccess: true });
    }
  }

  componentWillUnmount() {
    notificationTC.destroy();
  }

  processar = () => {
    this.setState({ process: true });
  }

  updateTable = (process) => {
    this.loadRequerimentoShapeFile(process);
  }

  show = (color, message) => {
    return notificationTC.notice({
      content: <FullWideNotification
        color={color}
        message={message}
        />,
      duration: 3,
      closable: true,
      style: { top: 0, left: 0 },
      className: `full ltr-support`,
    });
  };

  render() {
    const { t } = this.props;

    let view = '';
    let disabled = this.state.process;
    let notOK = !hasAccess("MENU_REQUIREMENT_SHP_PROCESSING");


    if(this.state.hasAccess){
      if(this.state.process){
        view =  <CrudEdit 
                  files={this.state.data.filter(obj => obj.statusLoad !== "PROCESSADO")}
                  estados = {this.state.estados}
                  requerimentoEventos = {this.state.requerimentoEventos}
                  requerimentoFase = {this.state.requerimentoFase}
                  substancia = {this.state.substancia}
                  substanciaUso = {this.state.substanciaUso}
                  updateTable = {this.updateTable} />
      }else{
        view =  <MatTable 
                  title={t('forms.list')}
                  list={this.state.data}
                  updateTable = {this.updateTable} />
      }
    }

    return (
      <>
        <Row>
          <Col md={10}>
            <h3 className="page-title">{t('forms.requerimentoShapeFile_form.title')}</h3>
            <h3 className="page-subhead subhead">{t('forms.requerimentoShapeFile_form.description')}</h3>
          </Col>
          <Col md={2}>
            <ButtonToolbar className="form__button-toolbar" style={{float: 'right'}}>
              <Button className="icon" color="primary" type="submit" disabled={disabled || notOK}
                onClick={e => this.processar()}>
                <DatabaseImportIcon /> {t('forms.processar')}
              </Button>
            </ButtonToolbar>
          </Col>
        </Row>

        <Row>
          {view}
        </Row>
      </>
    );
  }
}

export default withTranslation('common')(CrudList);